import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {Mutation} from 'react-apollo';
import {Col, Row} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {PulseLoader} from 'react-spinners';
import styled from 'styled-components';
import {checkErrorType, createUserAuthTokens, getPrimaryRoute} from '../../utils';
import LoginButton from '../../common/components/LoginButton';
import Tooltip from '../../common/components/Tooltip';
import {ERROR_TYPE_AUTH_ERROR, ERROR_TYPE_INACTIVE_ACCOUNT} from '../../common/constants';

export const AttributeDiv = styled.div`
  ${({uppercase}) => uppercase && `
    text-transform: uppercase;
  `};
  font-family: 'Segoe UI Bold', sans-serif;
  font-size: 12px;
`;

const login = gql`
    mutation login($email: String!, $password: String!) {
        login(email: $email, password: $password) {
            id
            token
            user {
                id
                firstName
                lastName
                email
                role
            }
        }
    }
`;

const LoginForm = ({t, history}) => {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loginError, setError] = useState(null);

  const submitCredentials = (login, event) => {
    if (event) {
      event.preventDefault();
    }
    setSubmitted(true);

    if (email !== '' && password !== '') {
      login({variables: {email, password}})
        .then(async res => {
          await createUserAuthTokens(res.data.login);
          history.push(getPrimaryRoute(res.data.login.user.role));
        }).catch(error => {
          if (checkErrorType(error, ERROR_TYPE_INACTIVE_ACCOUNT)) {
            setError(t('login.form.inactive'));
          } else if (checkErrorType(error, ERROR_TYPE_AUTH_ERROR)) {
            setError(t('login.form.invalidCredentials'));
          } else {
            console.error(error);
            setError(t('login.errorMsg'));
          }
        });
    }
  };

  return (
    <Mutation mutation={login}>
      {(login, {loading}) =>{
        return (
          <Row>
            <Col xs={{span: 10, offset: 1}} lg={{span: 6, offset: 3}} xl={{span: 4, offset: 4}} className="inputs-block">
              <form onSubmit={e => submitCredentials(login, e)}>
                <div className="login-title">{t('login.form.login')}</div>
                <Row>
                  <Col xs={{span: 10, offset: 1}}>
                    <label className="mandatory-label">
                      <AttributeDiv className="label-name">{`${t('login.form.field.email')} : `}</AttributeDiv>
                      <input
                        className="login-input"
                        type="text"
                        name="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        placeholder={t('login.form.field.emailPlaceHolder')}
                      />
                    </label>
                    <Tooltip show={(submitted && email === '')} color={'red'}>
                      {t('requiredField')}
                    </Tooltip>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{span: 10, offset: 1}}>
                    <label className="mandatory-label">
                      <AttributeDiv className="label-name">{`${t('login.form.field.pass')} : `}</AttributeDiv>
                      <input
                        className="login-input"
                        type="password"
                        name="password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        placeholder={t('login.form.field.passwordPlaceHolder')}
                      />
                    </label>
                    <Tooltip show={loginError !== null || (submitted && password === '')} color={'red'}>
                      {submitted && password === '' ? t('requiredField') : loginError}
                    </Tooltip>
                  </Col>
                  <Col xs={{span: 10, offset: 1}} style={{marginTop: '25px'}} className="forgot-pass-col">
                    <Link to="/forgot-password" className="forgot-pass">{t('login.btn.forgotPass')}</Link>
                  </Col>
                  <Col xs={{span: 10, offset: 1}}>
                    {loading ? (
                      <div className="centered-loader">
                        <PulseLoader />
                      </div>
                    ) : (
                      <LoginButton type="submit" onClick={e => submitCredentials(login, e)}>{t('login.form.login')}</LoginButton>
                    )}
                  </Col>
                </Row>
              </form>
            </Col>
            <Col xs={{span: 10, offset: 1}} lg={{span: 6, offset: 3}} xl={{span: 4, offset: 4}} className="white-centered">
              {`${t('login.btn.notReg')} `}
              <Link to="/register" className="underline">{t('login.btn.sign')}</Link>
            </Col>
            <Col xs={{span: 10, offset: 1}} lg={{span: 6, offset: 3}} xl={{span: 4, offset: 4}} className="white-centered">
              {`${t('login.merchant.contact')} `}
              <Link to="/become_partner" className="underline">{t('login.merchant.link')}</Link>
            </Col>
          </Row>
        );
      }}
    </Mutation>
  );
};

LoginForm.propTypes = {
  t: PropTypes.func,
  history: PropTypes.object,
};

export default withTranslation('login')(LoginForm);
